import React, { useEffect, useState } from "react";
import { APP_ROUTES } from "../app/constants/module";
import { AuthService } from "../services";
import { removeState } from "../utils/localStorage.util";
import Loading from "../app/components/Loading";

export function withProfile<T>(Component: any) {
  return (props: Omit<T, "profile">) => {
    const [profile, setProfile] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
      let cancelled = false;
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await AuthService.authProfile();
          if (cancelled) return;
          if (res && (res.status === 200 || res.status === 204)) {
            setProfile(res.data?.data || null);
            setUnauthorized(false);
          } else if (res && res.status === 401) {
            setUnauthorized(true);
          } else {
            setUnauthorized(true);
          }
        } catch {
          if (!cancelled) setUnauthorized(true);
        } finally {
          if (!cancelled) setLoading(false);
        }
      };
      fetchData();
      return () => {
        cancelled = true;
      };
    }, []);

    useEffect(() => {
      if (!unauthorized) return;
      removeState();
      window.location.href = APP_ROUTES.SIGN_IN;
    }, [unauthorized]);

    if (loading) {
      return <Loading style={{ margin: "2rem 0", height: "100vh" }} />;
    }

    if (unauthorized || !profile) {
      return null;
    }

    return <Component {...props} profile={profile} />;
  };
}
